import { ajaxRequest } from '../services/ajax-service';
import { SUGGEST_TIMEOUT, SUGGEST_START_LIMIT } from '../constants';

/**
 * Ключ: значение из админки
 * Значение: ключ полей из DaData
 */
const COMPANY_REG_MAP = {
    UF_COMPANY_ADR: 'ADDRESS',
    UF_INN: 'INN',
    UF_KPP: 'KPP',
    UF_COMPANY: 'VALUE',
};

/**
 * Ключ: значение из админки
 * Значение: ключ полей из DaData
 */
const BANK_REG_MAP = {
    UF_BIC: 'BIC',
    UF_BANK_CITY: 'CITY',
    UF_BANK_NAME: 'VALUE',
    UF_CHECKING_ACCOUNT: '',
    UF_CORR_ACCOUNT: 'CORR_ACCOUNT',
    // INN
    // KPP
};

const NEW_PERSON_COMPANY = {
    NAME: 'LOCATION_VALUE',
    INN: 'INN',
};

/**
 * formModel - данные формы
 */
export const dadataMixin = {
    data() {
        return {
            suggestCity: [],
            suggestAddress: [],

            suggestCompanyName: [],
            suggestCompanyINN: [],
            suggestCompanyKPP: [],

            suggestBank: [],

            // добавление комании в заказе для физика
            suggestPersonCompanyInn: [],
            suggestPersonCompanyName: [],

            isSuggestLoading: false,
            SUGGEST_TIMER: null,
        };
    },

    methods: {
        completeCompany(item) {
            setTimeout(() => {
                Object.keys(COMPANY_REG_MAP).forEach((sector) => {
                    const value = COMPANY_REG_MAP[sector];

                    if (sector === 'UF_COMPANY_ADR') {
                        this.formModel[sector] = item[value].LOCATION_VALUE;
                    } else {
                        this.formModel[sector] = item[value];
                    }

                    this.formModel = { ...this.formModel };
                });
            }, 0);
        },

        completeCompanyOrder(item) {
            setTimeout(() => {
                console.log(item);
                Object.keys(COMPANY_REG_MAP).forEach((sector) => {
                    const value = COMPANY_REG_MAP[sector];

                    if (sector === 'UF_COMPANY_ADR') {
                        this.formData[sector] = item[value].LOCATION_VALUE;
                    } else {
                        this.formData[sector] = item[value];
                    }

                    this.formData = { ...this.formData };
                });
            }, 0);
        },

        completeBank(item) {
            setTimeout(() => {
                Object.keys(BANK_REG_MAP).forEach((sector) => {
                    const value = BANK_REG_MAP[sector];

                    if (sector === 'UF_COMPANY_ADR') {
                        this.formModel[sector] = item[value].LOCATION_VALUE;
                    } else {
                        this.formModel[sector] = item[value];
                    }

                    this.formModel = { ...this.formModel };
                });
            }, 0);
        },

        completePersonCompany(item) {
            setTimeout(() => {
                const data = {};
                Object.keys(NEW_PERSON_COMPANY).forEach((sector) => {
                    const value = NEW_PERSON_COMPANY[sector];
                    data[sector] = item[value];
                });
                this.newPersonCompany = { ...data };
            }, 0);
        },

        prepareSuggestFormData(query) {
            const formData = new FormData();
            formData.append('query', query);

            return formData;
        },

        prepareSuggestFormDataKPP(query) {
            const formData = new FormData();
            formData.append('query', this.formModel.UF_INN);
            formData.append('kpp', query);

            return formData;
        },

        /**
         * Запрос на сервер
         * @param {String} url
         * @param {FormData} formData
         * @param {String} suggestType - определяем переменную, куда "складывать" подсказку
         */
        getSuggestList(url, formData, suggestType) {
            this.isSuggestLoading = true;
            this.formStatus = null;
            this.SUGGEST_TIMER = setTimeout(() => {
                this[suggestType] = 'search';
                ajaxRequest(url, { query: formData })
                    .then((response) => {
                        const { data, textStatus } = response;
                        if (data && textStatus === 'success') {
                            this[suggestType] = data?.data || [];
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this[suggestType] = [];
                        this.isSuggestLoading = false;
                    })
                    .finally(() => {
                        this.isSuggestLoading = false;
                    });
            }, SUGGEST_TIMEOUT);
        },

        // Ищем город
        getSuggestCity(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            const url = '/api/search/location/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestCity');
        },

        // Ищем компанию по названию
        getSuggestCompanyName(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            const url = '/api/search/company/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestCompanyName');
        },

        // ищем компанию по ИНН
        getSuggestCompanyINN(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            const url = '/api/search/company/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestCompanyINN');
        },

        // ищем компанию по КПП (нужно ещё добавить ИНН в запрос, без него не взлетит)
        getSuggestCompanyKPP(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            // ИНН обязателен при поиске по КПП
            if (!this.formModel.UF_INN) return;

            const url = '/api/search/company/by-kpp/';
            const formData = this.prepareSuggestFormDataKPP(query);

            this.getSuggestList(url, formData, 'suggestCompanyKPP');
        },

        // Ищем банк по БИК
        getSuggestBank(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            const url = '/api/search/bank/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestBank');
        },

        getSuggestAddresses(query) {
            this.suggestAddress = [];
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            const url = '/api/search/address/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestAddress');
        },

        // ищем компании в заказе для физика по ИНН
        getSuggestPersonCompanyInn(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.toString().length < SUGGEST_START_LIMIT) return;

            // const url = '/api/user-company/by-inn/';
            const url = '/api/search/company/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestPersonCompanyInn');
        },

        // ищем компании в заказе для физика по названию
        getSuggestPersonCompanyName(query) {
            clearTimeout(this.SUGGEST_TIMER);
            if (query.length < SUGGEST_START_LIMIT) return;

            const url = '/api/search/company/';
            const formData = this.prepareSuggestFormData(query);

            this.getSuggestList(url, formData, 'suggestPersonCompanyName');
        },
    },
};
